<mat-card appearance="outlined">
  <mat-card-header>
    <mat-card-title>
      <h1>{{ 'billing.holidays.title' | translate }}</h1>
    </mat-card-title>
  </mat-card-header>
  <mat-card-content>
    <section class="creation-form">
      <button *ngIf="!isCreationMode" (click)="onEdit()" [matTooltip]="'billing.holidays.add' | translate" mat-mini-fab
        class="action-button" color="primary">
        <mat-icon aria-label="Add">add</mat-icon>
      </button>
      <app-holiday-edit *ngIf="isCreationMode && !editedId" (editFinished)="onEditFinished()"></app-holiday-edit>
    </section>

    <section>
      <form [formGroup]="groupForm" class="groupForm">
        <app-autocomplete [control]="getGroupControl('group')" [list]="holidayGroups"
          label="billing.holidays.chooseGroup">
        </app-autocomplete>
        <button type="button" mat-raised-button color="primary" (click)="chooseHolidayGroup()"
          [disabled]="groupForm.invalid">Choisir groupe</button>
      </form>
    </section>

    <mat-form-field class="filterField" *ngIf="dataSource">
      <mat-label>Filtrer</mat-label>
      <input matInput (keyup)="applyFilter($event)" placeholder="Votre filtre" #input>
    </mat-form-field>

    <section class="datatable-holidays" *ngIf="dataSource">
      <table mat-table [dataSource]="dataSource" matSort multiTemplateDataRows>
        <ng-container matColumnDef="date">
          <th mat-header-cell *matHeaderCellDef mat-sort-header> Date </th>
          <td mat-cell *matCellDef="let holiday"> {{ holiday.date | amDateFormat: 'DD/MM/YYYY'}} </td>
        </ng-container>

        <ng-container matColumnDef="description">
          <th mat-header-cell *matHeaderCellDef mat-sort-header> Description </th>
          <td mat-cell *matCellDef="let holiday"> {{ holiday.description }} </td>
        </ng-container>

        <ng-container matColumnDef="actions">
          <th mat-header-cell *matHeaderCellDef> {{ 'billing.holidays.list.actions' | translate }} </th>
          <td mat-cell *matCellDef="let holiday">
            <ng-container *ngIf="holiday.id !== editedId">
              <button mat-icon-button class="action-button" color="primary" [disabled]="isLoading"
                [matTooltip]="'billing.holidays.list.edit' | translate" (click)="onEdit(holiday.id)">
                <mat-icon aria-label="Edit">edit</mat-icon>
              </button>
            </ng-container>
            <ng-container>
              <button mat-icon-button class="action-button" color="primary" [disabled]="isLoading"
                [matTooltip]="'billing.holidays.list.delete' | translate" (click)="delete(holiday.id)">
                <mat-icon aria-label="Delete">delete</mat-icon>
              </button>
            </ng-container>
          </td>
        </ng-container>

        <ng-container matColumnDef="expandedDetail">
          <td mat-cell *matCellDef="let holiday" [attr.colspan]="displayedColumns.length">
            <div *ngIf="holiday.id === editedId" class="row-edit"
              [@detailExpand]="holiday.id === editedId ? 'expanded' : 'collapsed'">
              <app-holiday-edit [holiday]="holiday" (editFinished)="onEditFinished()"></app-holiday-edit>
            </div>
          </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns;" class="row"
          [ngClass]="{ 'expanded-row': row.id === editedId }"></tr>
        <tr mat-row *matRowDef="let row; columns: ['expandedDetail']" class="detail-row"></tr>
      </table>
      <mat-paginator [pageSizeOptions]="[20, 25, 50, 100]" showFirstLastButtons [length]="holidays.length"
        class="paginator"></mat-paginator>
    </section>
    <mat-progress-bar *ngIf="isLoading" class="progress-bar" mode="indeterminate" color="primary"></mat-progress-bar>
  </mat-card-content>
</mat-card>